import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const unreadMessage = async (id: string): Promise<AxiosResponse> =>
  AxiosInstance.post('subscriptions.unread', {
    roomId: id,
  });
